var _path, _path2, _circle, _circle2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHappy = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 14.6666C11.6818 14.6666 14.6666 11.6818 14.6666 7.99992C14.6666 4.31802 11.6818 1.33325 7.99992 1.33325C4.31802 1.33325 1.33325 4.31802 1.33325 7.99992C1.33325 11.6818 4.31802 14.6666 7.99992 14.6666Z",
    stroke: "#008908",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7006 9.88549C11.9532 10.0142 12.0559 10.3253 11.9002 10.5622C11.5243 11.1345 11.0257 11.6189 10.4382 11.9789C9.70443 12.4286 8.86056 12.6666 7.99992 12.6666C7.13928 12.6666 6.29541 12.4286 5.56159 11.9789C4.97416 11.6189 4.47558 11.1345 4.0996 10.5622C3.94394 10.3253 4.04667 10.0142 4.29927 9.88549C4.55188 9.75678 4.8582 9.85991 5.02113 10.0919C5.30613 10.4977 5.67214 10.8425 6.09802 11.1035C6.6704 11.4543 7.32862 11.6399 7.99992 11.6399C8.67122 11.6399 9.32944 11.4543 9.90181 11.1035C10.3277 10.8425 10.6937 10.4977 10.9787 10.0919C11.1416 9.85991 11.448 9.75678 11.7006 9.88549Z",
    fill: "#008908"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.33325,
    cy: 7.66675,
    r: 1,
    fill: "#008908"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6667,
    cy: 7.66675,
    r: 1,
    fill: "#008908"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHappy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/happy.3b080cf1.svg";
export { ForwardRef as ReactComponent };